var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleCreatePlan1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 87,
    viewBox: "0 0 110 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7461 43.5003L45.3096 6.58594V80.4146L23.7461 43.5003Z",
    fill: "#FF6D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110 43.5003L88.4366 6.58594V80.4146L110 43.5003Z",
    fill: "#FF6D3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3096 6.58594H88.4366V80.4146H45.3096V6.58594Z",
    fill: "#FF6D3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 43.5L25.4921 0V87L0 43.5Z",
    fill: "#D33500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.968 43.5L76.4762 0V87L101.968 43.5Z",
    fill: "#D33500"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4921 0H76.4762V87H25.4921V0Z",
    fill: "#D33500"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9683,
    cy: 23.2229,
    rx: 13.9683,
    ry: 13.8645,
    fill: "#FF6D3D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1237 71H62.464V16H51.4387L33.2471 31.1483L39.941 38.7613L51.1237 29.0508V71Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleCreatePlan1);
export default __webpack_public_path__ + "static/media/titleCreatePlan1.51e5697952e0d14215b116a809940254.svg";
export { ForwardRef as ReactComponent };